import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as moment from "moment"
import * as React from "react"
import { injectIntl, InjectedIntlProps, FormattedNumber } from "react-intl"
import { connect } from "react-redux"
import { bindActionCreators, Dispatch } from "redux"
import CounterMenu from "./counter-menu"
import CounterChart from "./counter-chart"
import CounterTable from "./counter-table"
import CounterUploader from "./counter-uploader"
import { findCurrentValidatedScenario } from "../../service/sfp/scenarii-service"
import { findServiceGroups } from "../../service/sfp/service-group-service"
import * as Model from "../../model"
import * as actionCreators from "../../action-creators"
import { ReducerState, MappedActionsProps } from "../../reducer"
import { hasAllThemesValidated } from "../../domain/sfp/scenario-domain"
import * as CounterDomain from "../../domain/sfp/counter-domain"
import { getProfile, Profile } from "../../domain/sfp/user-domain"
import { findLocalAuthoritySituation } from "../../service/sfp/situation-service"
import CounterDetail, { ViewableBudgetEvolution } from "./counter-detail"
import { Switch, Route, Redirect, RouteProps } from "react-router"
import * as Routes from "../../util/routes"
import Notification, { NotificationLevel } from "../notification"
import '../style/counter.scss'
import 'moment/locale/fr'
class CounterContainer
    extends React.Component<InjectedProps, State> {
    private readonly now = new Date()
    private dayOfYear = moment(this.now).dayOfYear()
    private daysInYear = moment(this.now).isLeapYear() ? 366 : 365
    private abortController = new AbortController

    constructor(props: Readonly<InjectedProps>) {
        super(props)
        this.state = {
            budgetEvolutions: [],
            errors: [],
            serviceGroups: [],
            loadingScenario: false,
            loadingServiceGroups: false,
            loadingSituation: false,
            situationRecords: [],
            scenario: null,
            scenarioLoaded: false,
            serviceGroupsLoaded: false,
            situationLoaded: false,
            viewDetail: null
        }
    }

    componentDidMount() {
        this.fetchResources()
    }

    componentDidUpdate(
        prevProps: Readonly<InjectedProps>,
        prevState: Readonly<State>
    ) {
        const localAuthorityChanged = prevProps.currentLocalAuthority !== this.props.currentLocalAuthority

        if (localAuthorityChanged) return this.fetchResources()

        const scenarioChanged = prevState.scenario !== this.state.scenario
        const servicesChanged = prevProps.currentLocalAuthorityServices !== this.props.currentLocalAuthorityServices
        const serviceGroupsChanged = prevState.serviceGroups !== this.state.serviceGroups
        const situationRecordsChanged = prevState.situationRecords !== this.state.situationRecords

        if (this.state.situationRecords !== null && this.state.situationRecords != undefined && Array.isArray(this.state.situationRecords)
            && this.state.situationRecords.length > 0) {
            const dateDerniereMiseAJour = Math.max.apply(null, this.state.situationRecords.map(function (e) {
                return new Date(e.updatedAt).getTime();
            }));
            this.dayOfYear = moment(dateDerniereMiseAJour).dayOfYear();
            this.daysInYear = moment(dateDerniereMiseAJour).isLeapYear() ? 366 : 365
        }

        if (scenarioChanged || servicesChanged || serviceGroupsChanged || situationRecordsChanged)
            return this.setState({ budgetEvolutions: this.createBudgetEvolutions() })
    }

    componentWillUnmount() {
        this.abortController.abort()
    }

    render() {
        return <section className="section" style={{ height: "100%" }}>
            {this.renderErrorNotifications()}
            {this.renderContent()}
        </section>
    }

    private createBudgetEvolutions(): CounterDomain.BudgetEvolution[] {
        const serviceBudgetEvolutions = this.props.currentLocalAuthorityServices
            .map<CounterDomain.ServiceBudgetEvolution>(s => {
                return this.getServiceBudgetEvolution(s)
            })
            .sort((b1, b2) => b1.label > b2.label ? 1 : -1)
        const serviceGroupBudgetEvolutions = this.state.serviceGroups
            .map<CounterDomain.ServiceGroupBudgetEvolution>(g => {
                return this.getServiceGroupBudgetEvolution(g, serviceBudgetEvolutions)
            })
            .sort((b1, b2) => b1.label > b2.label ? 1 : -1)

        const ungroupedServiceBudgetEvolutions = serviceBudgetEvolutions
            .filter(s => null === s.serviceGroup)

        if (hasAllThemesValidated(this.state.scenario, this.props.currentLocalAuthorityServices))
            return [
                this.getGlobalBudgetEvolution(serviceBudgetEvolutions),
                ...serviceGroupBudgetEvolutions,
                ...ungroupedServiceBudgetEvolutions
            ]

        return [
            ...serviceGroupBudgetEvolutions,
            ...ungroupedServiceBudgetEvolutions,
        ]
    }

    private fetchResources() {
        if (!this.state.loadingScenario && !this.state.scenarioLoaded)
            this.forceFetchingScenario()

        if (!this.state.loadingServiceGroups && !this.state.serviceGroupsLoaded)
            this.forceFetchingServiceGroups()

        if (!this.state.loadingSituation && !this.state.situationLoaded)
            this.forceFetchingSituation()
    }

    private forceFetchingScenario() {
        if (!this.props.currentLocalAuthority) return

        this.setState({
            loadingScenario: true,
            scenario: null,
            scenarioLoaded: false
        }, () => {
            findCurrentValidatedScenario(this.props.currentLocalAuthority)
                .then(scenario => this.setState({
                    loadingScenario: false,
                    scenario,
                    scenarioLoaded: true
                }))
                .catch(reason => {

                    this.setState(prevState => {
                        prevState.errors.push({
                            id: Symbol(),
                            message: "Une erreur est survenue lors du chargement d'un scénario \
						validé pour l'année en cours."
                        })

                        return {
                            errors: prevState.errors,
                            loadingScenario: false,
                            scenario: null,
                            scenarioLoaded: true
                        }
                    })
                })
        })
    }

    private forceFetchingServiceGroups() {
        if (!this.props.currentLocalAuthority) return

        this.setState({
            loadingServiceGroups: true,
            serviceGroups: [],
            serviceGroupsLoaded: false
        }, () => {
            findServiceGroups(this.props.currentLocalAuthority)
                .then(groups => this.setState({
                    loadingServiceGroups: false,
                    serviceGroups: groups,
                    serviceGroupsLoaded: true
                }))
                .catch(reason => {

                    this.setState(prevState => {
                        prevState.errors.push({
                            id: Symbol(),
                            message: "Une erreur est survenue lors du chargement des groupes de \
						services."
                        })

                        return {
                            errors: prevState.errors,
                            loadingServiceGroups: false,
                            serviceGroups: [],
                            serviceGroupsLoaded: true
                        }
                    })
                })
        })
    }

    private forceFetchingSituation() {
        if (!this.props.currentLocalAuthority) return

        this.setState({
            loadingSituation: true,
            situationLoaded: false,
            situationRecords: []
        }, () => {
            findLocalAuthoritySituation(this.props.currentLocalAuthority, this.abortController.signal)
                .then(situationRecords => this.setState({
                    loadingSituation: false,
                    situationRecords,
                    situationLoaded: true
                }))
                .catch(reason => {
                    this.setState(prevState => {
                        prevState.errors.push({
                            id: Symbol(),
                            message: "Une erreur est survenue lors du chargement des lignes de \
						compteur."
                        })

                        return {
                            errors: prevState.errors,
                            loadingSituation: false,
                            situationRecords: [],
                            situationLoaded: true
                        }
                    })
                })
        })
    }

    private getGlobalBudgetEvolution(
        serviceBudgetEvolutions: CounterDomain.ServiceBudgetEvolution[]
    ): CounterDomain.GlobalBudgetEvolution {
        const annualBudget = CounterDomain.getGlobalAnnualBudget(serviceBudgetEvolutions)
        const repository = CounterDomain.getRepository(annualBudget, 1, this.dayOfYear, this.daysInYear)
        const totalExpense = CounterDomain.getGlobalTotalExpense(serviceBudgetEvolutions)
        const consumption: CounterDomain.Consumption = {
            absolute: CounterDomain.getAbsoluteConsumption(totalExpense, repository),
            percentage: CounterDomain.getPercentageConsumption(totalExpense, repository)
        }
        const availableBudget = CounterDomain.getAvailableBudget(annualBudget, totalExpense)
        const engaged = CounterDomain.getGlobalEngaged(serviceBudgetEvolutions)
        const levelOfConsumption = CounterDomain.getLevelOfConsumption(consumption.percentage)
        const liquidated = CounterDomain.getGlobalLiquidated(serviceBudgetEvolutions)
        const planned = CounterDomain.getGlobalPlanning(serviceBudgetEvolutions)
        const available = CounterDomain.getAvailableBudgetTotal(liquidated, engaged, planned)

        return {
            annualBudget,
            availableBudget,
            consumption,
            engaged,
            isGlobal: true,
            label: "Global",
            levelOfConsumption,
            liquidated,
            plannedConsumption: 1,
            repository,
            slug: "global",
            totalExpense,
            available,
            planned,
        }
    }

    private getServiceBudgetEvolution(
        service: Model.Service
    ): CounterDomain.ServiceBudgetEvolution {
        const serviceRecords = CounterDomain
            .filterRecordsByService(this.state.situationRecords, service)
        const { engaged, liquidated, available, planned } = CounterDomain.sumBudgets(serviceRecords)
        const totalExpense = CounterDomain.getTotalExpense(engaged, liquidated)
        const budgetEvolution: CounterDomain.ServiceBudgetEvolution = {
            ...service,
            annualBudget: null,
            availableBudget: null,
            consumption: null,
            engaged,
            levelOfConsumption: null,
            liquidated,
            repository: null,
            totalExpense,
            available,
            planned,
        }

        budgetEvolution.plannedConsumption = null != budgetEvolution.plannedConsumption
            ? budgetEvolution.plannedConsumption
            : 1

        if (this.state.scenario) {
            budgetEvolution.annualBudget = CounterDomain
                .getAnnualBudget(service, this.state.scenario)

            budgetEvolution.availableBudget = CounterDomain
                .getAvailableBudget(budgetEvolution.annualBudget, totalExpense)

            budgetEvolution.repository = CounterDomain
                .getRepository(budgetEvolution.annualBudget, budgetEvolution.plannedConsumption, this.dayOfYear, this.daysInYear)

            budgetEvolution.consumption = {
                absolute: CounterDomain
                    .getAbsoluteConsumption(totalExpense, budgetEvolution.repository),

                percentage: CounterDomain
                    .getPercentageConsumption(totalExpense, budgetEvolution.repository)
            }

            budgetEvolution.levelOfConsumption = CounterDomain
                .getLevelOfConsumption(budgetEvolution.consumption.percentage)

        }

        return budgetEvolution
    }

    private getServiceGroupBudgetEvolution(
        serviceGroup: Model.ServiceGroup,
        serviceBudgetEvolutions: CounterDomain.ServiceBudgetEvolution[]
    ): CounterDomain.ServiceGroupBudgetEvolution {
        const filteredServiceBudgetEvolutions = serviceBudgetEvolutions
            .filter(s => serviceGroup.services.some(id => id === s.id))

        const initial: CounterDomain.ServiceGroupBudgetEvolution = {
            ...serviceGroup,
            annualBudget: 0,
            availableBudget: 0,
            consumption: { absolute: 0, percentage: 0 },
            engaged: 0,
            levelOfConsumption: 0,
            liquidated: 0,
            plannedConsumption: 1,
            repository: 0,
            serviceBudgets: filteredServiceBudgetEvolutions,
            totalExpense: 0,
            available: 0,
            planned: 0,
        }

        const budgetEvolution = filteredServiceBudgetEvolutions
            .reduce<CounterDomain.ServiceGroupBudgetEvolution>((r, s) => {
                return {
                    ...r,
                    annualBudget: r.annualBudget + s.annualBudget,
                    engaged: r.engaged + s.engaged,
                    liquidated: r.liquidated + s.liquidated,
                    totalExpense: r.totalExpense + s.totalExpense,
                    planned: r.planned + s.planned
                }
            }, initial)

        if (this.state.scenario) {
            budgetEvolution.availableBudget = CounterDomain
                .getAvailableBudget(budgetEvolution.annualBudget, budgetEvolution.totalExpense)

            budgetEvolution.available = CounterDomain
                .getAvailableBudgetTotal(budgetEvolution.liquidated, budgetEvolution.engaged, budgetEvolution.planned)

            budgetEvolution.repository = CounterDomain
                .getRepository(budgetEvolution.annualBudget, budgetEvolution.plannedConsumption, this.dayOfYear, this.daysInYear)

            budgetEvolution.consumption = {
                absolute: CounterDomain
                    .getAbsoluteConsumption(budgetEvolution.totalExpense, budgetEvolution.repository),

                percentage: CounterDomain
                    .getPercentageConsumption(budgetEvolution.totalExpense, budgetEvolution.repository)
            }

            budgetEvolution.levelOfConsumption = CounterDomain
                .getLevelOfConsumption(budgetEvolution.consumption.percentage)
        } else {
            budgetEvolution.annualBudget = null
            budgetEvolution.availableBudget = null
            budgetEvolution.repository = null
            budgetEvolution.consumption = null
            budgetEvolution.levelOfConsumption = null
        }
        return budgetEvolution
    }

    private handleClickCloseViewDetail(e: React.SyntheticEvent<Element>) {
        this.setState({ viewDetail: null })
    }

    private handleClickViewDetail(budgetEvolution: ViewableBudgetEvolution) {
        this.setState({ viewDetail: budgetEvolution })
    }

    private handleCloseError(error: { id: Symbol; message: string }): void {
        this.setState(prevState => {
            const index = prevState.errors.findIndex(e => e.id === error.id)
            if (index >= 0) prevState.errors.splice(index, 1)
            return { errors: prevState.errors }
        })
    }

    private handlePlannedConsumptionChange(
        budgetEvolution: CounterDomain.BudgetEvolution
    ): void {
        if (CounterDomain.isServiceBudgetEvolution(budgetEvolution)) {
            const services = this.props.currentLocalAuthorityServices.slice()
            const service = services.find(s => s.id === budgetEvolution.id)
            service.plannedConsumption = budgetEvolution.plannedConsumption
            this.props.actions.updateServicesLocally(services)
        } else {
            this.setState(prevState => {
                const index = CounterDomain.isServiceGroupBudgetEvolution(budgetEvolution)
                    ? prevState.budgetEvolutions.findIndex(e => CounterDomain.isServiceGroupBudgetEvolution(e) && e.id === budgetEvolution.id)
                    : 0

                if (-1 === index) return

                prevState.budgetEvolutions[index].plannedConsumption = budgetEvolution.plannedConsumption

                return { budgetEvolutions: prevState.budgetEvolutions }
            })
        }
    }

    private renderConsumption(
        budgetEvolution: CounterDomain.BudgetEvolution
    ): React.ReactNode {
        if (!budgetEvolution.consumption) return

        const directionLabel = budgetEvolution.consumption.absolute < 0
            ? "une économie"
            : "un dépassement"

        const icon = CounterDomain
            .getLevelOfConsumptionIcon(budgetEvolution.levelOfConsumption)

        return <p>
            <span className="icon">
                <FontAwesomeIcon color={icon.color} icon={icon.name} />
            </span>

            <strong>
                Pourcentage de consommation:&nbsp;
                <FormattedNumber
                    style="percent"
                    value={budgetEvolution.consumption.percentage} />
            </strong>

            &nbsp;(soit {directionLabel} de <FormattedNumber
                currency="EUR"
                style="currency"
                value={Math.abs(budgetEvolution.consumption.absolute)} />
        </p>
    }

    private renderContent(): React.ReactNode {
        const currentUser = this.props.currentUser
        const userProfile = currentUser ? getProfile(currentUser) : null
        const loadingMainResources = this.props.loadingCurrentLocalAuthority
            || this.props.loadingCurrentLocalAuthorityServices

        if (loadingMainResources)
            return <progress className="progress is-primary is-small" />

        const budgetEvolutions = this.state.budgetEvolutions
        return <div className="tile is-vertical" style={{ height: "100%" }}>
            {this.renderUploader(userProfile)}

            <div className="tile" style={{ minHeight: 0 }}>
                <div className="tile is-parent is-4" style={{ overflow: "auto" }}>
                    <CounterMenu
                        budgetEvolutions={budgetEvolutions}
                        loading={this.state.loadingServiceGroups}
                        localAuthority={this.props.currentLocalAuthority} />
                </div>

                <div className="tile is-parent">
                    <Switch>
                        {this.renderRoutes(budgetEvolutions, userProfile)}
                    </Switch>
                </div>

                {this.state.viewDetail &&
                    <CounterDetail
                        records={this.state.situationRecords}
                        budgetEvolution={this.state.viewDetail}
                        services={this.props.currentLocalAuthorityServices}
                        onClickCloseButton={e => this.handleClickCloseViewDetail(e)} />}
            </div>
        </div>
    }

    private renderCounter(
        title: string,
        budgetEvolution: CounterDomain.BudgetEvolution,
        profile: Profile
    ): React.ReactNode {
        return <div className="tile is-child">
            <header className="level is-mobile">
                <h2 className="level-left title is-4">
                    <span className="level-item">{title}</span>

                    {!CounterDomain.isGlobalBudgetEvolution(budgetEvolution) &&
                        <button
                            className="button is-primary level-item"
                            onClick={() => this.handleClickViewDetail(budgetEvolution)}
                            type="button">
                            Voir le détail
                        </button>}
                    {budgetEvolution.planned != budgetEvolution.annualBudget &&
                        <span style={{ color: "orange", marginLeft: "10px", fontSize: "16px", }}><FontAwesomeIcon
                            icon="exclamation-triangle" />   Attention, le budget annuel est différent du total prévu</span>}
                </h2>
                <p className="date">
                    {this.state.situationRecords.length > 0 ?
                        moment(this.state.situationRecords[this.state.situationRecords.length - 1].updatedAt, 'YYYY-MM-DDThh:mm:ssZ').locale('fr').format('dddd D MMMM YYYY') :
                        ""
                    }
                </p>
            </header>

            {this.renderScenarioStatus()}

            <CounterTable
                budgetEvolution={budgetEvolution}
                dayOfYear={this.dayOfYear}
                daysInYear={this.daysInYear}
                profile={profile}
                onPlannedConsumptionChange={e => this.handlePlannedConsumptionChange(e)} />
            <div className="content">
                {this.renderConsumption(budgetEvolution)}
                <CounterChart budgetEvolution={budgetEvolution} />
            </div>
        </div>
    }

    private renderErrorNotifications(): React.ReactNode {
        return this.state.errors.map(e =>
            <Notification
                level={NotificationLevel.Danger}
                message={e.message}
                onClickCloseButton={() => this.handleCloseError(e)} />)
    }

    private renderRoutes(
        budgets: CounterDomain.BudgetEvolution[],
        userProfile: Profile,
        parentPath?: string
    ): React.ReactElement<RouteProps>[] {
        const basePath = parentPath || `${Routes.LOCAL_AUTHORITY_PATTERN}${Routes.PROJECTION_COUNTERS}`
        const routes = budgets
            .reduce<React.ReactElement<RouteProps>[]>((result, budgetEvolution, i) => {
                let title = "Global"
                let path = `${basePath}/global`
                let subRoutes: React.ReactElement<RouteProps>[]

                if (CounterDomain.isServiceBudgetEvolution(budgetEvolution)) {
                    title = budgetEvolution.label
                    path = `${basePath}/${budgetEvolution.slug}`
                } else if (CounterDomain.isServiceGroupBudgetEvolution(budgetEvolution)) {
                    title = budgetEvolution.label
                    path = `${basePath}/${budgetEvolution.slug}`
                    subRoutes = this.renderRoutes(budgetEvolution.serviceBudgets, userProfile, path)
                }

                result.push(<Route
                    exact
                    key={i}
                    path={path}
                    render={() => this.renderCounter(title, budgetEvolution, userProfile)} />)

                return subRoutes ? [...result, ...subRoutes] : result
            }, [])

        // Ajout d'une redirection vers le premier budget si aucun n'est sélectionné
        if (!parentPath && routes.length) {
            routes.push(<Redirect
                exact
                from={basePath}
                key={routes.length}
                to={routes[0].props.path as string} />)
        }

        return routes
    }

    private renderScenarioStatus(): React.ReactNode {
        if (this.state.loadingScenario)
            return <p>
                Recherche du scénario validé pour l'année en cours...
                <progress className="progress is-primary is-small is-fullwidth" />
            </p>

        if (!(this.state.loadingScenario || this.state.scenario)) {
            const message = "Aucun scénario validé pour l'année en cours n'a été \
			trouvé. Le budget annuel et les valeurs qui en découlent (référentiel, \
			budget disponible, consommation) ne peuvent être calculés."
            return <Notification message={message} level={NotificationLevel.Warning} />
        }
    }

    private renderUploader(userProfile: Profile): React.ReactNode {
        const localAuthority = this.props.currentLocalAuthority

        if (!localAuthority) return
        if (localAuthority.bergerLevrault && localAuthority.bergerLevrault.enabled) return
        if (Profile.SuperAdmin !== userProfile && Profile.LocalAuthorityAdmin !== userProfile) return
        return <CounterUploader
            localAuthority={this.props.currentLocalAuthority}
            scenario={this.state.scenario}
            situationRecord={this.state.situationRecords} />
    }
}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
    return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
    return state
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CounterContainer))

interface State {
    budgetEvolutions: CounterDomain.BudgetEvolution[];
    errors: { id: Symbol, message: string }[];
    serviceGroups: Model.ServiceGroup[];
    loadingScenario: boolean;
    loadingServiceGroups: boolean;
    loadingSituation: boolean;
    situationRecords: Model.SituationRecord[];
    scenario: Model.Scenario;
    scenarioLoaded: boolean;
    serviceGroupsLoaded: boolean;
    situationLoaded: boolean;
    viewDetail: ViewableBudgetEvolution;
}

type InjectedProps = MappedActionsProps & ReducerState & InjectedIntlProps



// WEBPACK FOOTER //
// ./src/component/counter/index.tsx